/**
 * Recado que a sessão deixa para a tela de login quando ela é encerrada sozinha
 * (fora da janela de horário, login desativado no cadastro, etc.). Fica no
 * sessionStorage porque o encerramento faz um reload real para /login.
 */
export const CHAVE_MENSAGEM_SESSAO = "auth-mensagem-sessao";

export function guardarMensagemSessao(mensagem: string): void {
  if (typeof window === "undefined" || !mensagem) return;
  try {
    window.sessionStorage.setItem(CHAVE_MENSAGEM_SESSAO, mensagem);
  } catch {
    /* sessionStorage indisponível: segue mesmo assim */
  }
}

/** Lê e apaga o recado — ele vale uma única exibição. */
export function consumirMensagemSessao(): string {
  if (typeof window === "undefined") return "";
  try {
    const mensagem = window.sessionStorage.getItem(CHAVE_MENSAGEM_SESSAO) || "";
    if (mensagem) window.sessionStorage.removeItem(CHAVE_MENSAGEM_SESSAO);
    return mensagem;
  } catch {
    return "";
  }
}
